module.exports = __webpack_public_path__ + "files/93e8b8c6a28ba931f8eec5a721bed528.png";